import { polyfillElementMethods } from './utils/polyfill'
import { scrollTop } from './utils/scroll-top'
import { expandTextarea } from './utils/expand-textarea'
import { svgxuse } from './libs/svgxuse'
import { customSelect } from './libs/custom-select'


const scrollElement = document.querySelector('.btn__up')

if (scrollElement) {
  scrollTop(scrollElement)
}

function controlLanguageMenu() {
  const formChangeLang = document.getElementById('form-change-lang')

  if (formChangeLang) {
    const select = document.getElementById('lang-cite')
    const borderSelect = document.querySelector('#form-change-lang .form-block__border')

    formChangeLang.addEventListener('change', (event) => {
      const optionValue = event.target.value

      window.location.href = optionValue
    })

    customSelect(select, borderSelect)
  }
}

polyfillElementMethods(window)
expandTextarea()
svgxuse()
controlLanguageMenu()
